module.exports = __webpack_public_path__ + "img/guyana.c775c004.svg";